// extracted by mini-css-extract-plugin
module.exports = {"video-container":"VideoLabel_video-container__A90PM","video-duration":"VideoLabel_video-duration__6_58O"};